import { Component, inject, OnInit, signal } from '@angular/core';
import { NgClass } from '@angular/common';
import { HeaderComponent } from 'src/app/components/header/header.component';
import { BaseComponent } from 'src/app/components/_base/base.component';
import { BreadcrumbComponent } from './breadcrumb/breadcrumb.component';
import { BannerComponent } from './banner/banner.component';
import { LayoutService } from 'src/app/services/layout/layout.service';
import { AuthService } from 'src/app/services/auth/auth.service';
import { SidebarComponent } from './sidebar/sidebar/sidebar.component';
import { HistoryShortcutDirective } from 'src/app/components/history-shortcut/history-shortcut.directive';
import { HistorySheetContainerComponent } from 'src/app/components/history-sheet/history-sheet-container.component';
import { AgentChatLauncherComponent } from 'src/app/components/agent-chat/launcher/agent-chat-launcher.component';

@Component({
  templateUrl: './layout.component.html',
  standalone: true,
  selector: 'app-layout',
  imports: [
    HeaderComponent,
    BreadcrumbComponent,
    NgClass,
    BannerComponent,
    SidebarComponent,
    HistoryShortcutDirective,
    HistorySheetContainerComponent,
    AgentChatLauncherComponent,
  ],
})
export class LayoutComponent extends BaseComponent implements OnInit {
  private readonly layoutService = inject(LayoutService);
  private readonly authService = inject(AuthService);

  readonly fullscreenMode = signal(false);

  get isAdmin() {
    return this.authService.isAdmin;
  }

  ngOnInit() {
    this.sub$ = this.layoutService.fullscreenMode$.subscribe((mode) => this.fullscreenMode.set(mode));
  }
}
